export default __webpack_public_path__ + "static/media/630.0dee5b7c.gif";